import { useEffect, useState } from "react";

function GameStatus({ status }) {
  const [def, setDef] = useState("");

  useEffect(() => {
    switch (status) {
      case "F":
        setDef("Final");
        break;
      case "TBP":
        setDef("To Be Played");
        break;
      case "CAN":
        setDef("Canceled");
        break;
      case "PPD":
        setDef("Postponed");
        break;
      case "SPD":
        setDef("Suspended");
        break;
      case "FFT":
        setDef("Forfeit");
        break;
      case "N/R":
        setDef("Score Not Reported");
        break;
      case "N/C":
        setDef("Not Confirmed");
        break;
      // Additional cases as needed
      default:
        setDef("");
    }
  }, []);

  return (
    <div className="relative flex justify-center text-center gameStatus w-full ">
      <p className="status absolute duration-500">{status.toUpperCase()}</p>
      <p className="def hidden absolute duration-500">{def.toUpperCase()}</p>
    </div>
  );
}

export default GameStatus;
